export const ACTIVE_CONTENT = 'active_content';
export const ACTIVE_USERS = 'active_users';
export const COMPUTE = 'compute';
export const CONTENT_TYPE = 'content_type';

export const allMetrics = [ COMPUTE, ACTIVE_USERS, ACTIVE_CONTENT ];

export const contentFields = [ COMPUTE, CONTENT_TYPE ];

